import React from "react";

export default function CurrentWeatherLine() {
  return (
    <div className="col-1 vertical-line">
      <i className="fa-solid fa-grip-lines-vertical"></i>
    </div>
  );
}
